import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { adminListApiKeys, listUsers } from "../lib/api";
import { useAuth } from "../lib/auth";
import { KeyTable } from "../components/KeyTable";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Label } from "../components/ui/label";

export function AdminKeysRoute() {
  const { me } = useAuth();
  const [userId, setUserId] = useState<string>("");
  const [onlyActive, setOnlyActive] = useState(false);

  const users = useQuery({
    queryKey: ["admin", "users", "all-for-filter"],
    queryFn: () => listUsers(),
    staleTime: 60_000,
  });

  const keys = useQuery({
    queryKey: ["admin", "keys", userId, onlyActive],
    queryFn: () =>
      adminListApiKeys({
        user_id: userId || undefined,
        only_active: onlyActive,
      }),
  });

  if (!me?.is_admin) {
    return (
      <div className="rounded-md border bg-card p-6 text-sm">
        Kein Admin-Zugriff.
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Alle API-Keys</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap items-end gap-3">
          <div className="space-y-1">
            <Label htmlFor="user-filter">User</Label>
            <select
              id="user-filter"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              className="h-9 rounded-md border border-input bg-background px-2 text-sm"
            >
              <option value="">Alle</option>
              {users.data?.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.email}
                </option>
              ))}
            </select>
          </div>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={onlyActive}
              onChange={(e) => setOnlyActive(e.target.checked)}
            />
            Nur aktive Keys
          </label>
        </div>
        {keys.isLoading && <p className="text-sm">Lade…</p>}
        {keys.isError && (
          <p className="text-sm text-destructive">
            Konnte Keys nicht laden.
          </p>
        )}
        {keys.data && <KeyTable keys={keys.data} showOwner />}
      </CardContent>
    </Card>
  );
}
